// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import anjLogoUrl from '../../assets/img/mobile/anj.jpg';
import config from '../../config/app.config';
import { __, getLang } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  font-size: 0.65em;
  padding: 1em;
  line-height: normal;
  color: ${theme.Legal.color};
`;

const ArjelLogo = styled.div`
  background-image: url(${anjLogoUrl});
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 3.125em;
  max-width: 50px;
  height: 2.5em;
  max-height: 40px;
  float: left;
  margin-right: 0.5em;
`;

const ArjelLicenceWrapper = styled.div`
  font-size: 1.1em;
  display: flex;
  align-items: center;
  margin: 0 auto;
`;

const LegalText = styled.a`
  && {
    display: block;
    color: ${theme.Legal.color};
  }
`;

const LegalFr = () => {
  return (
    <>
      <Wrapper>
        <p>{__('!desc:ArjelTitle')}</p>
        <ArjelLicenceWrapper>
          <ArjelLogo />
          <div>
            N°003-PO-2010-06-05
            <br />
            N°003-PS-2014-05-14
          </div>
        </ArjelLicenceWrapper>
        <LegalText
          target="_blank"
          href={`${config.webHost[getLang()]}/CLIC/PREVENTION/INTVOL_ROS/anj.fr/ts?external=1`}
        >
          <p>{__('!desc:ArjelLink')}</p>
          <p>{__('!desc:ArjelAdvice')}</p>
        </LegalText>

        <LegalText
          target="_blank"
          href={`${config.webHost[getLang()]}/CLIC/PREVENTION/JIS_HOME/www.joueurs-info-service.fr?external=1`}
        >
          {__('!desc:ResponsibleGamingTextFR')}
        </LegalText>
      </Wrapper>
    </>
  );
};

export default React.memo<unknown>(LegalFr);
